import React from 'react';
import { Text } from '../Text';

const AuthenticationPreview = ({ content, securityDisclaimer, expirationWarning, authCTA }) => {
  const getCTALabel = () => {
    switch (authCTA) {
      case 'COPY_CODE':
        return 'Copy code';
      case 'AUTOFILL':
        return 'Autofill';
      default:
        return null;
    }
  };

  return (
    <>
      {/* BODY */}
      <div className="mx-2 mt-2">
        {content && (
          <Text type="sub-heading" style={{ whiteSpace: 'pre-line' }}>
            {content}
          </Text>
        )}
      </div>

      {/* OTP CARD */}
      <div className="mx-2 mt-2">
        <div
          style={{
            background: '#f5f6f7',
            borderRadius: '10px',
            padding: '12px',
          }}
        >
          {/* OTP */}
          <div
            style={{
              fontSize: '22px',
              fontWeight: '600',
              letterSpacing: '4px',
              textAlign: 'center',
              marginBottom: '8px',
            }}
          >
            123456
          </div>

          {/* EXPIRY */}
          {expirationWarning && (
            <Text
              type="sub-heading"
              color="grey"
              style={{ fontSize: '0.75rem', textAlign: 'center' }}
            >
              This code expires in 10 minutes
            </Text>
          )}
        </div>
      </div>

      {/* SECURITY DISCLAIMER */}
      {securityDisclaimer && (
        <div className="mx-2 mt-2">
          <Text
            type="sub-heading"
            color="grey"
            style={{ fontSize: '0.75rem', textAlign: 'center' }}
          >
            For your security, do not share this code
          </Text>
        </div>
      )}

      {/* CTA */}
      {authCTA !== 'NONE' && (
        <div className="mx-2 mt-2 mb-2">
          <div
            className="p-2 text-center"
            style={{
              background: '#f5f6f7',
              borderRadius: '10px',
            }}
          >
            <Text type="sub-heading" color="#25D366">
              {getCTALabel()}
            </Text>
          </div>
        </div>
      )}
    </>
  );
};

export default AuthenticationPreview;
